const INITIAL_STATE = {
    isConnectedWithPictoBlox: false,
    currentSelectedBoard: "None"
}

const reducer = (state=INITIAL_STATE,action) =>
{
    switch(action.type)
    {
        case "BOARD_CHANGE":
            return{
                ...state,
                currentSelectedBoard:action.board
            }
        case "CONNECTION_UPDATE":
            return{
                ...state,
                isConnectedWithPictoBlox:action.status
            }
        default:
            return state;
    }
}

const updateBoard = (boardName) =>{
    return {
        type: "BOARD_CHANGE",
        board: boardName
    }
}

const updateConnectionStatus = (status) =>{
    return {
        type: "CONNECTION_UPDATE",
        status: status
    }
}

export {
    reducer as default,
    updateBoard,
    updateConnectionStatus
}